import { Typography } from '@mui/material'

export const TextCardField = ({ entityObj, fieldDef }) => {
  return <Typography>{entityObj[fieldDef.field]}</Typography>
}